import TradesTable from "../components/TradeTable";
import { useTrades } from "../hooks/useTrades";
import TradeChart from "../components/TradeChart";

export default function TradesPage() {
  const { trades, closeTrade } = useTrades();

  // Mocked chart data, you can replace with real history
  // const chartData = trades?.map((trade: any) => ({
  //   timestamp: new Date(trade.timestamp).toLocaleTimeString(),
  //   price: trade.entryPrice,
  // }));

  return (
    <div>
      <h2 className="text-2xl font-semibold mb-4">Trades</h2>
      {/* <TradeChart data={chartData} /> */}
      <TradesTable trades={trades} closeTrade={closeTrade} />
    </div>
  );
}
